// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'

export default class Copyright extends React.Component {

  render () {
    return (
      <p>
        Copyright © 2019-2020 Verimatrix, Inc. All rights reserved. <br />
        Verimatrix products and services may not be accessed or used without a written agreement with Verimatrix, Inc.
      </p>
    )
  }
}
